import { Box, Typography } from '@mui/material'
import React from 'react'
import placeholderImage from '../../assets/images/placeholderImage.png'

export const CardOption: ReactFC<{
  onClick: () => void
  imageUrl?: string
  title: string
  description: string
}> = ({ onClick, imageUrl, title, description }) => {
  return (
    <Box
      onClick={() => onClick()}
      sx={{
        width: '233px',
        minHeight: '257px',
        padding: '1rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '0.25rem',
        boxShadow: 3,
        cursor: 'pointer',
        userSelect: 'none',
        justifyContent: 'center',
        borderRadius: 2
      }}
    >
      <img
        src={imageUrl ?? placeholderImage}
        alt=''
      />
      <Typography
        sx={{
          fontWeight: '600',
          textAlign: 'center',
          whiteSpace: 'nowrap',
          marginTop: '1rem'
        }}
      >
        {title}
      </Typography>
      <Typography
        sx={{
          textAlign: 'center', fontSize: '.9rem'
        }}
      >
        {description}
      </Typography>
    </Box>
  )
}

export default CardOption
